import React, { useEffect, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover,
    Row,
    Col
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import lowPrio from "../../../../Assets/Images/Revenue-management/lowPriority.svg";
import highPrio from "../../../../Assets/Images/Revenue-management/highPriority.svg";
import normalPrio from "../../../../Assets/Images/CRM/normalPrio.svg";
import DatePicker from "react-datepicker";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";
import ToolsSummaryModal from "../../ToolsSummaryModal";
import EventViewModal from "../../../CommonComponent/EventViewModal";

import nextMonth from "../../../../Assets/Images/Revenue-management/nextMonth.svg";
import preMonth from "../../../../Assets/Images/Revenue-management/preMonth.svg";

export const PaceIQ = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const tableData = [
        {
            "AsOfDate": "1900-01-04",
            "Dates": "1900-01-04",
            "OTB": 0,
            "RMS": 0,
            "Occperc": 0,
            "Occpercchange": 0,
            "Cancellations": 0,
            "LYRMS": 0,
            "STLYRMS": 0,
            "LYOccPer": 0,
            "ADR": 0,
            "ADRPerc_change": 0,
            "LYADR": 0,
            "STLYADR": 0,
            "BAR": 0,
            "Revenue": 0,
            "CompSetAvg": 0,
            "CompSetMin": 0,
            "CompSetMax": 0,
            "Events": 0,
            "System_forecast_otb": 0,
            "Nova_forecast_otb": 0,
            "User_forecast_otb": 0,
            "STLYOccper": 0
        },
        {
            "AsOfDate": "1900-01-04",
            "Dates": "1900-01-04",
            "OTB": 0,
            "RMS": 0,
            "Occperc": 0,
            "Occpercchange": 0,
            "Cancellations": 0,
            "LYRMS": 0,
            "STLYRMS": 0,
            "LYOccPer": 0,
            "ADR": 0,
            "ADRPerc_change": 0,
            "LYADR": 0,
            "STLYADR": 0,
            "BAR": 0,
            "Revenue": 0,
            "CompSetAvg": 0,
            "CompSetMin": 0,
            "CompSetMax": 0,
            "Events": 0,
            "System_forecast_otb": 0,
            "Nova_forecast_otb": 0,
            "User_forecast_otb": 0,
            "STLYOccper": 0
        },
        {
            "AsOfDate": "1900-01-04",
            "Dates": "1900-01-04",
            "OTB": 0,
            "RMS": 0,
            "Occperc": 0,
            "Occpercchange": 0,
            "Cancellations": 0,
            "LYRMS": 0,
            "STLYRMS": 0,
            "LYOccPer": 0,
            "ADR": 0,
            "ADRPerc_change": 0,
            "LYADR": 0,
            "STLYADR": 0,
            "BAR": 0,
            "Revenue": 0,
            "CompSetAvg": 0,
            "CompSetMin": 0,
            "CompSetMax": 0,
            "Events": 0,
            "System_forecast_otb": 0,
            "Nova_forecast_otb": 0,
            "User_forecast_otb": 0,
            "STLYOccper": 0
        },
        {
            "AsOfDate": "1900-01-04",
            "Dates": "1900-01-04",
            "OTB": 0,
            "RMS": 0,
            "Occperc": 0,
            "Occpercchange": 0,
            "Cancellations": 0,
            "LYRMS": 0,
            "STLYRMS": 0,
            "LYOccPer": 0,
            "ADR": 0,
            "ADRPerc_change": 0,
            "LYADR": 0,
            "STLYADR": 0,
            "BAR": 0,
            "Revenue": 0,
            "CompSetAvg": 0,
            "CompSetMin": 0,
            "CompSetMax": 0,
            "Events": 0,
            "System_forecast_otb": 0,
            "Nova_forecast_otb": 0,
            "User_forecast_otb": 0,
            "STLYOccper": 0
        },
        {
            "AsOfDate": "1900-01-04",
            "Dates": "1900-01-04",
            "OTB": 0,
            "RMS": 0,
            "Occperc": 0,
            "Occpercchange": 0,
            "Cancellations": 0,
            "LYRMS": 0,
            "STLYRMS": 0,
            "LYOccPer": 0,
            "ADR": 0,
            "ADRPerc_change": 0,
            "LYADR": 0,
            "STLYADR": 0,
            "BAR": 0,
            "Revenue": 0,
            "CompSetAvg": 0,
            "CompSetMin": 0,
            "CompSetMax": 0,
            "Events": 0,
            "System_forecast_otb": 0,
            "Nova_forecast_otb": 0,
            "User_forecast_otb": 0,
            "STLYOccper": 0
        }
    ];
    const [SelectDate, setSelectDate] = useState(para?.asOfDate);
    const [tblids, settblids] = useState({
        id: commonService.GenerateGUID(),
        id1: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [selectSevenPickupDate, setSelectSevenPickupDate] = useState();
    const sevenMaxDateRef = useRef();

    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const [showToolsSummaryModal, setToolsSummaryModal] = useState(false);
    const closeToolsSummaryModal = () => {
        setToolsSummaryModal(false);
    };
    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const [PaceIQData, setPaceIQData] = useState(tableData);
    const [PaceIQData_loader, setPaceIQData_loader] = useState(false);
    const PaceIqAPICall = async () => {
        setPaceIQData_loader(true)

        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);

        let req = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PACEIQ.PACEIQ,
                body: {
                    "propertyCode": para?.propertyCode,
                    "SelectedDate": commonService.getDateInDBFormat(SelectDate),
                    channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                },
            },
            false
        );

        let res = apiResponse(false, req);


        if (res?.isValidate) {
            setPaceIQData(res?.data?.data)

        }

        setPaceIQData_loader(false)
    }
    const selectedTdIndexRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const eventListPropsRef = useRef();

    useEffect(() => {
        if (api === 0) {

        } else {
            if (SelectDate) {
                PaceIqAPICall();
                getEventList();
            }
        }
    }, [SelectDate]);

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };
    const handleFilterBtnClick = (event) => {
        // let screenY = event.screenY;
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        // let Left = event.nativeEvent.layerX + 30;
        if (Top + 400 > window.innerHeight) {
            // Top = Top - 400;
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const [showTicketModal, setShowTicketModal] = useState(false);

    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        // Property: { top: 0, left: 0 },
        Target: null,
        Position: "top",
    });

    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        // setONTHEBOOKS({ IsDisplay: false, Property: { top: 0, left: 0 } });
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.id} .perbackground-otb`
    );
    const eventListRef = useRef();
    const getEventList = async () => {
        let eventList = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(propertyDetailFromRTK?.propertyid),
                    startdate: commonService.getDateInDBFormat(SelectDate),
                    enddate: commonService.getDateInDBFormat(SelectDate),
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false
        );

        let eventListResponse = apiResponse(false, eventList);

        if (eventListResponse?.isValidate) {
            let eventListArr = [];

            eventListResponse?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                }
                catch (err) { }
            });
            eventListRef.current = eventListArr;
        }

        if (!eventListResponse?.isValidate) {
            eventListRef.current = [];
        }
    };

    function SetNextPrevDate(val) {

        let newDate = new Date(SelectDate);
        newDate = newDate.setDate(newDate.getDate() + val);
        setSelectDate(newDate);
    }


    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("PaceIQ", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id + "," + tblids.id1,
                                    "PaceIQ",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PaceIQ", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.PaceIQ,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PaceIQ", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.id + "," + tblids.id1}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.id + "," + tblids.id1,
                                    `${para?.propertyCode}-PaceIQ-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <Row>
                <Col xl={12} className={"text-center"}>
                    <div className="flex-container mb-3">
                        <div class="flex-child align-middle text-end cursorPointer">
                            {
                                PaceIQData_loader ? <img src={preMonth} alt="" /> : <img id={commonService.generateGlobalClickTrackerID("PaceIQ", "premonth", propertyCode)} src={preMonth} alt="" onClick={(e) => SetNextPrevDate(-1)} />
                            }

                        </div>
                        <div class="flex-child align-middle " style={{ maxWidth: "200px" }}>
                            <b> {commonService.getDateInFormat(SelectDate)}</b>
                        </div>
                        <div class="flex-child align-middle text-start cursorPointer">
                            {
                                PaceIQData_loader ? <img src={nextMonth} alt="" /> : <img id={commonService.generateGlobalClickTrackerID("PaceIQ", "nextmonth", propertyCode)} src={nextMonth} alt="" onClick={(e) => SetNextPrevDate(1)} />
                            }

                        </div>
                    </div>
                </Col>
            </Row>
            <div className="ViewPropertySetupTable mb-3">
                <div className="table-responsive tblDynamicPickupSticky">
                    <Table id={tblids.id1}>
                        <tbody>
                            {
                                PaceIQData_loader ?
                                    (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    )
                                    :
                                    (
                                        <>
                                            <tr>
                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-1"}>OTB :</td>
                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-1"}><b>{PaceIQData && PaceIQData[0].OTB ? PaceIQData[0].OTB : 0}</b></td>

                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-2"}>STLY RMS :</td>
                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-2"}><b>{PaceIQData && PaceIQData[0].STLYRMS ? PaceIQData[0].STLYRMS : 0}</b></td>

                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-3"}>System Forecast :</td>
                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-3"}><b>{PaceIQData && PaceIQData[0].System_forecast_otb ? PaceIQData[0].System_forecast_otb : 0}</b></td>

                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-4"}>BAR :</td>
                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-4"}><b id={commonService.generateGlobalClickTrackerID("PaceIQ", "b-onclick", propertyCode)} style={{
                                                    cursor: "pointer",
                                                    backgroundColor: "rgb(240, 178, 178)",
                                                    padding: "3px",
                                                    borderRadius: "3px"
                                                }} onClick={() => {
                                                    setToolsSummaryModal(true);
                                                }}>{commonService.formateAmount(PaceIQData && PaceIQData[0].BAR ? PaceIQData[0].BAR : 0)}</b></td>

                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-5"}>Event :</td>
                                                <td style={{ width: "10%" }} className={"PaceIQ-summary-5"}><b id={commonService.generateGlobalClickTrackerID("PaceIQ", "b-onclick", propertyCode)} style={{
                                                    cursor: "pointer",
                                                    backgroundColor: "rgb(188, 213, 251)",
                                                    padding: "3px",
                                                    borderRadius: "3px"
                                                }}
                                                    onClick={() => {
                                                        let checkEvent = eventListRef.current?.filter(
                                                            (x) => {
                                                                let checkingDate = moment(SelectDate);
                                                                let startingDate = moment(x?.startDate);
                                                                let endingDate = moment(x?.endDate);
                                                                if (
                                                                    checkingDate.isSameOrAfter(startingDate) &&
                                                                    checkingDate.isSameOrBefore(endingDate)
                                                                ) {
                                                                    return x;
                                                                }
                                                            }
                                                        );
                                                        eventListPropsRef.current = checkEvent;
                                                        setShowTicketModal(true);
                                                    }}
                                                >{PaceIQData && PaceIQData[0].Events ? PaceIQData[0].Events : 0}</b></td>
                                            </tr>
                                            <tr>
                                                <td className={"PaceIQ-summary-1"}>Occ% :</td>
                                                <td className={"PaceIQ-summary-1"}><b>{PaceIQData && PaceIQData[0].Occperc ? PaceIQData[0].Occperc : 0}</b></td>

                                                <td className={"PaceIQ-summary-2"}>LY RMS :</td>
                                                <td className={"PaceIQ-summary-2"}><b>{PaceIQData && PaceIQData[0].LYRMS ? PaceIQData[0].LYRMS : 0}</b></td>

                                                <td className={"PaceIQ-summary-3"}>User Forecast :</td>
                                                <td className={"PaceIQ-summary-3"}><b>{PaceIQData && PaceIQData[0].User_forecast_otb ? PaceIQData[0].User_forecast_otb : 0}</b></td>

                                                <td className={"PaceIQ-summary-4"}>CompSet Min. :</td>
                                                <td className={"PaceIQ-summary-4"}><b>{commonService.formateAmount(PaceIQData && PaceIQData[0].CompSetMin ? PaceIQData[0].CompSetMin : 0)}</b></td>

                                                <td className={"PaceIQ-summary-5"}>Arrival Date</td>
                                                <td className={"PaceIQ-summary-5"}>
                                                    <DatePicker
                                                        portalId="datepicker-root"
                                                        className=" "
                                                        id="ArrivalDate"
                                                        selected={SelectDate ? commonService.convertDateInTimezone(SelectDate) : ""
                                                        }
                                                        onChange={(date) => {
                                                            setSelectDate(date);
                                                        }}
                                                    /></td>
                                            </tr>
                                            <tr>
                                                <td className={"PaceIQ-summary-1"}>ADR :</td>
                                                <td className={"PaceIQ-summary-1"}><b style={{
                                                    backgroundColor: (PaceIQData && PaceIQData[0].CompSetAvg ? PaceIQData[0].CompSetAvg : 0) > PaceIQData && PaceIQData[0].ADR ? PaceIQData[0].ADR : 0 ? "#00800080" : "#ec0f0f80",
                                                    padding: "3px",
                                                    borderRadius: "3px"
                                                }}>{commonService.formateAmount(PaceIQData && PaceIQData[0].ADR ? PaceIQData[0].ADR : 0)}</b></td>

                                                <td className={"PaceIQ-summary-2"}>STLY ADR :</td>
                                                <td className={"PaceIQ-summary-2"}><b>{commonService.formateAmount(PaceIQData && PaceIQData[0].STLYADR ? PaceIQData[0].STLYADR : 0)}</b></td>

                                                <td className={"PaceIQ-summary-3"}>RM Copilot Forecast :</td>
                                                <td className={"PaceIQ-summary-3"}><b>{PaceIQData && PaceIQData[0].Nova_forecast_otb ? PaceIQData[0].Nova_forecast_otb : 0}</b></td>



                                                <td className={"PaceIQ-summary-4"}>CompSet Avg. :</td>
                                                <td className={"PaceIQ-summary-4"}><b style={{
                                                    backgroundColor: (PaceIQData && PaceIQData[0].CompSetAvg ? PaceIQData[0].CompSetAvg : 0) > PaceIQData && PaceIQData[0].ADR ? PaceIQData[0].ADR : 0 ? "#ec0f0f80" : "#00800080",
                                                    padding: "3px",
                                                    borderRadius: "3px"
                                                }}>{commonService.formateAmount(PaceIQData && PaceIQData[0].CompSetAvg ? PaceIQData[0].CompSetAvg : 0)}</b></td>

                                                <td className={"PaceIQ-summary-5"}></td>
                                                <td className={"PaceIQ-summary-5"}></td>
                                            </tr>
                                            <tr>
                                                <td className={"PaceIQ-summary-1"}>Revenue :</td>
                                                <td className={"PaceIQ-summary-1"}><b>{commonService.formateAmount(PaceIQData && PaceIQData[0].Revenue ? PaceIQData[0].Revenue : 0)}</b></td>


                                                <td className={"PaceIQ-summary-2"}>LY ADR :</td>
                                                <td className={"PaceIQ-summary-2"}><b>{commonService.formateAmount(PaceIQData && PaceIQData[0].LYADR ? PaceIQData[0].LYADR : 0)}</b></td>

                                                <td className={"PaceIQ-summary-3"}>RMS Forecast :</td>
                                                <td className={"PaceIQ-summary-3"}><b>-</b></td>


                                                <td className={"PaceIQ-summary-4"}>CompSet Max. :</td>
                                                <td className={"PaceIQ-summary-4"}><b>{commonService.formateAmount(PaceIQData && PaceIQData[0].CompSetMax ? PaceIQData[0].CompSetMax : 0)}</b></td>


                                                <td className={"PaceIQ-summary-5"}></td>
                                                <td className={"PaceIQ-summary-5"}></td>
                                            </tr></>
                                    )
                            }

                        </tbody>
                    </Table>
                </div>
            </div>

            <div className="ViewPropertySetupTable">
                {
                    <div className="stripped__table">
                        <div className="table-responsive tblDynamicPickupSticky">
                            <Table id={tblids.id}>
                                <thead>
                                    <tr>
                                        <th>As Of Date</th>
                                        <th>No Of Days</th>
                                        <th>Arrival Date</th>
                                        <th className={"text-center border-right"}>OTB</th>
                                        <th className={"text-center"}>RMS</th>
                                        <th className={"border-right"}>Occ%</th>
                                        <th>OCC Change%</th>
                                        <th>LY-OCC%</th>
                                        <th>STLY-OCC%</th>
                                        <th className={"text-center border-right"}>Cancellation</th>
                                        <th className={"border-right text-end"}>ADR</th>
                                        <th>ADR Change%</th>
                                        <th className={"text-end"}>LY-ADR</th>
                                        <th className={"text-end"}>STLY-ADR</th>
                                        <th className={"border-right text-end"}>Revenue</th>
                                        <th className={"text-end"}>CompSet MIN.</th>
                                        <th className={"text-end"}>CompSet Avg.</th>
                                        <th className={"text-end"}>CompSet MAX.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        PaceIQData_loader ?
                                            (
                                                <tr style={{ height: "80px", position: "relative" }}>
                                                    <Loader />
                                                </tr>
                                            )
                                            :
                                            (
                                                PaceIQData &&
                                                PaceIQData.map((item, index) => {
                                                    let Occpercchange = item.Occpercchange ? parseFloat(item.Occpercchange) : 0;
                                                    let ADRPerc_change = item.ADRPerc_change ? parseFloat(item.ADRPerc_change) : 0;
                                                    let ADR = 0;
                                                    let ADR_Class = "";
                                                    if (item.ADR) {
                                                        ADR = parseFloat(item.ADR);
                                                    }

                                                    let CompSetAvg = 0;
                                                    let CompSetAvg_Class = "";
                                                    if (item.CompSetAvg) {
                                                        CompSetAvg = parseFloat(item.CompSetAvg);
                                                    }

                                                    if (ADR === CompSetAvg) {
                                                        ADR_Class = "#00800080";
                                                        CompSetAvg_Class = "#00800080";
                                                    }
                                                    else if (ADR > CompSetAvg) {
                                                        ADR_Class = "#ec0f0f80";
                                                        CompSetAvg_Class = "#00800080";
                                                    }
                                                    else if (ADR < CompSetAvg) {
                                                        ADR_Class = "#00800080";
                                                        CompSetAvg_Class = "#ec0f0f80";
                                                    }


                                                    return (
                                                        <tr>
                                                            <td>{commonService.getDateInFormat(item.AsOfDate)}</td>
                                                            <td>{item.NoOfDays}</td>
                                                            <td>{commonService.getDateInFormat(item.Dates)}</td>
                                                            <td className={"text-center border-right text-primary perbackground perbackground-otb"} value={item.OTB ? commonService.formateRoom(item.OTB) : item.OTB}>
                                                                <span id={commonService.generateGlobalClickTrackerID("PaceIQ", "otb", item)}
                                                                    className={`${selectedTdIndexRef.current === index
                                                                        ? "singleDateSummarySpan"
                                                                        : ""
                                                                        }`}
                                                                    onClick={(e) => {
                                                                        singleDateSelectedDateRef.current = item.AsOfDate;
                                                                        handleFilterBtnClick(e);
                                                                        selectedTdIndexRef.current = index;
                                                                    }}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {item.OTB
                                                                        ? item.OTB
                                                                        : 0}
                                                                </span>
                                                            </td>
                                                            <td className={"text-center"}>{item.RMS}</td>

                                                            <td className={"border-right"}>{item.Occperc}</td>
                                                            <td className={`${Occpercchange !== 0 ? Occpercchange < 0 ? "redText" : "greenText" : ""}`}> {Occpercchange !== 0 ? <img src={Occpercchange < 0 ? lowPrio : highPrio} alt="" /> : <img src={normalPrio} alt="" />} {item.Occpercchange}</td>
                                                            <td>{item.LYOccPer}</td>
                                                            <td>{item.STLYOccper}</td>

                                                            <td className={"text-center border-right"}>{item.Cancellations}</td>

                                                            <td className={"border-right text-end"} style={{ backgroundColor: ADR_Class }}>{commonService.formateAmount(item.ADR)}</td>
                                                            <td className={`${ADRPerc_change !== 0 ? ADRPerc_change < 0 ? "redText" : "greenText" : ""}`}>{ADRPerc_change !== 0 ? <img src={ADRPerc_change < 0 ? lowPrio : highPrio} alt="" /> : <img src={normalPrio} alt="" />} {item.ADRPerc_change}</td>
                                                            <td className={"text-end"}>{commonService.formateAmount(item.LYADR)}</td>
                                                            <td className={"text-end"}>{commonService.formateAmount(item.STLYADR)}</td>

                                                            <td className={"border-right text-end"}>{commonService.formateAmount(item.Revenue)}</td>
                                                            <td className={"text-end"}>{commonService.formateAmount(item.CompSetMin)}</td>
                                                            <td className={"text-end"} style={{ backgroundColor: CompSetAvg_Class }}>{commonService.formateAmount(item.CompSetAvg)}</td>
                                                            <td className={"text-end"}>{commonService.formateAmount(item.CompSetMax)}</td>
                                                        </tr>
                                                    )
                                                })
                                            )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </div>
                }
            </div>

            {api !== 0 && <Comments widgetDetails={para} editorId={"PaceIQ"} />}

            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={singleDateSelectedDateRef.current}
                            selectedDate={SelectDate}
                            pickupDate={
                                selectSevenPickupDate
                                    ? selectSevenPickupDate
                                    : sevenMaxDateRef.current
                            }
                            propertyDetail={{ propertyCode: para?.propertyCode }}
                        />

                        {/*asOfDate={para?.asOfDate}*/}
                        {/*selectedDate={singleDateSelectedDateRef.current}*/}
                        {/*PickupDays={"1Day"}*/}
                    </div>
                </Popover>
            </Overlay>

            {showToolsSummaryModal && (
                <ToolsSummaryModal
                    showToolsSummaryModal={showToolsSummaryModal}
                    closeToolsSummaryModal={closeToolsSummaryModal}
                    selectedDate={SelectDate}
                    propertyDetail={propertyDetailFromRTK}
                />
            )}

            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={SelectDate}

                />
            )}
        </div>
    );
};

export default PaceIQ;
